import {types, flow, getRoot} from 'mobx-state-tree';

import {apiService} from '../services/api.service';
import Role from './role';

const Roles = types.model('Roles', {
  rolesList: types.optional(types.array(Role), []),
  selectedRole: types.maybeNull(types.reference(Role))
})
.actions((self) => ({
  fetchRoles: flow(function* fetchRoles() {
    if(self.rolesList.length > 0) return Promise.resolve();
    try {
      self.rolesList = yield apiService.getRoles();
    } catch (error) {
      console.error('Failed to fetch roles', error)
    }
  }),

  changeContentToRole(roleIdentifier) {
    if(roleIdentifier) {
      self.selectedRole = roleIdentifier;
      getRoot(self).ContentItems.fetchContentForRole(self.selectedRole);
    } else {
      self.resetContent()
    }
  },

  resetContent() {
    self.selectedRole = null;
    getRoot(self).ContentItems.fetchContentItems();
  }
}))
.views((self) => ({
  get allRoleSelectionOptions() {
    return self.rolesList.map(role => ({title: role.description}));
  }
}))

export default Roles;
